// Copyright (c) 2026 IOTA Stiftung
// SPDX-License-Identifier: Apache-2.0

export const IOTA_IDENTITY_PKG_ID = import.meta.env.VITE_IOTA_IDENTITY_PKG_ID;
export const DID_PROTOCOL_SEGMENT_SYMBOL = ':';
export const DID_URL_SEGMENT_SYMBOL = '-';
export const IDENTITY_WASM_PATH = '/identity_wasm_bg.wasm';
